// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_o6-0";